import BulletModel from "../models/BulletModel";
import CrusherModel from "../models/CrusherModel";
import OrbModel from "../models/OrbModel";
import PlatformModel from "../models/PlatformModel";
import PortalModel from "../models/PortalModel";
import SpikeModel from "../models/SpikeModel";

interface Coord {
    left: number,
    bottom: number
}

const SPEED_FACTORS = [0.8, 0.9, 1.2, 1.4, 1.6];

class SceneProperties {
    /**
     * DEBUG
     */
    // static battonTrackers;
    static isMute = false;
    static checkPoint: Coord | null = null;
    static speed = 3;

    static getSpeedFactor(){
        return SPEED_FACTORS[4 - (this.speed - 1)];
    }

    static totalWidthFact = 0.75;
    static platforms: PlatformModel[];
    static spikes: SpikeModel[];
    static crushers: CrusherModel[];
    static portals: PortalModel[];
    static battons: BattonModel[];
    static bullets: BulletModel[];
    static guns: PlatformModel[];
    static orbs: OrbModel[];

    static playerSize: number;
    static playerGlow: string | null;
    static getPlayerRadius = () => {
        return this.playerSize / 2;
    }

    static acceleration: number;
    static dragLimit: number;
    static topSpeed: number;

    static gravity: number;
    static getFallGravity = () => {
        return this.gravity * 2;
    }
    static getHeavyGravity = () => {
        return this.gravity * 1.5;
    }
    static jumpPower: number;
    static bleadTweak: number;

    static orbAmplitude: number;
    static bulletWidth: number;
    static bulletAmplitude: number;

}

export default SceneProperties